import { render, staticRenderFns } from "./Excursions.vue?vue&type=template&id=5e78da5b&scoped=true&"
import script from "./Excursions.vue?vue&type=script&lang=js&"
export * from "./Excursions.vue?vue&type=script&lang=js&"
import style0 from "./Excursions.vue?vue&type=style&index=0&id=5e78da5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78da5b",
  null
  
)

export default component.exports